<adb-global-loader />
@if (connectionCheck.isOnline$ | async) {
  <router-outlet />
} @else {
  <adb-app-offline />
}
